import { http, type HttpResponse, handleHttpRequest } from 'interfaces'
import { type PersonUrl } from '../../international/edit/personBasicInfoService'

export async function getPersonUrls (personId: number): Promise<HttpResponse<PersonUrl[]>> {
  return await http
    .get(`/api/v1/us/person/${personId}/url/`)
    .then(response => response.data)
}

export async function createPersonUrl (personId: number, urlData: PersonUrl): Promise<HttpResponse<PersonUrl>> {
  const payload = {
    ...urlData,
    id: 0
  }

  return await http
    .post('/api/v1/us/person/url/0/', payload)
    .then(response => response.data)
}

export async function updatePersonUrl (urlId: number, urlData: PersonUrl): Promise<HttpResponse<PersonUrl>> {
  const payload = {
    ...urlData
  }

  return await http
    .put(`/api/v1/us/person/url/${urlId}/`, payload)
    .then(response => response.data)
}

export async function deletePersonUrl (urlId: number): Promise<HttpResponse<void>> {
  return await http
    .delete(`/api/v1/us/person/url/${urlId}/`)
    .then(response => response.data)
}

export async function updateUsPersonUrlDisplayOrder (
  personId: number,
  displayOrderById: Record<number, number>,
  selectedUrlId: number,
  typeId: number
): Promise<HttpResponse<boolean>> {
  const urlPath = `/api/v1/us/person/${personId}/url/`

  const payload = {
    displayOrderById,
    selectedUrlId,
    typeId
  }

  return await handleHttpRequest(
    http.patch(urlPath, payload, { withCredentials: true })
  )
}
